module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc146554279"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_10"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("Live as if you were to die tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("Learn as if you were to live forever.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Mahatma Gandhi")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("Let me not then die ingloriously and without a struggle,")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("but let me first do some great thing")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("that shall be told among men hereafter.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Homer")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("The principal goal of education in the schools")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("should be creating men and women who are capable of doing new things,")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }, [_vm._v("not simply repeating what other generations have done.")]), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Jean Piaget")]), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_16"
  }, [_vm._v("A five-minute penalty for checking from behind. That’s what this is. Finish middle school on top, in charge, like you know everything. Then, wham…high school.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("Just when you think you’ve got a handle on things, life blindsides you, like getting a cheap shot while trying to dig the puck out of the corner. Confidence shaken, kinda gun-shy, you don’t chase after the puck with the same reckless abandon for a while. As long as you don’t get lit up again right away, eventually you’ll start getting comfortable on your skates and play your game again. At least, I’m hoping high school works the same as hockey. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("And life too, I suppose.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("Freshly out of the shower, I’m pulling on the new pair of jeans my mom bought me. Lucky me, she went all out and got me a few shirts, too. I know how tight money is, so I really appreciate the effort. Unlike Sharon, my older sister. She wouldn’t be happy even if my folks spent a million dollars on all the latest fashions for her to wear. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Ungrateful…")])]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Derek, honey,” Mom interrupts with a call and a knock at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Yeah?” I finish pulling one those new shirts over my head.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("She cracks the door to my room and peeks in. “First day of high school, I made a special breakfast,” her pleasant voice announces, her face adorned with the ever-present smile.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Be right out.” "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Moms! Just gotta love ’em")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I park at the dining room table and she sets a heaping plate in front of me. “Your favorite, ‘pakes and sup’.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("That’s what I used to say when I was little. She loves to bring that up every time we have ’em for breakfast. I’m not her baby anymore, but maybe she never wants me to grow up, her way of holding on. Still, she was right about a special breakfast—bacon and eggs and pancakes. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Best ever")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I’m going to town on the chow when I realize she just said something and raise my eyebrows to her.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“I said, your lunch is on the table,” she repeats, pointing to my right while simultaneously taking a sip from her coffee cup.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I glance over at a brown bag bulging with what I expect to be the usual fare—sandwich, chips, probably some fruit, maybe a few cookies. Next to it is a spiffy new backpack I haven’t seen before.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I swallow my current bite of pancakes and lick my lips. “What’s that?” I ask, pointing with my chin.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“You’re starting high school. I thought an important day in a young man’s life warrants something to commemorate it.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“That wasn’t necessary. My old one is still good.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Perhaps. But I wanted to.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("An obnoxious honk interrupts our conversation and I check my watch. Matt said his dad would give me a ride but they aren’t due for another ten minutes or so.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("Sharon bursts from her room down the hall and flashes through the kitchen.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“That’s Sissy.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Have a good day, honey,” Mom calls out to a slamming front door.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I see the disappointment registering on her face, but to her credit, she never says anything. My sister is a senior this year so today is a milestone for her too. And for my mom, though you’d never know it. Sharon’s sour disposition seems to spoil everything, even good stuff.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“You get her a new backpack too?” I ask facetiously, tipping my head toward the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Oh, no. That’d never do.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“What would?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("She shrugs and takes another sip of coffee. “A car,” she says nonchalantly, then a smile creeps over her face. “But a Ferrari is not in my budget.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("We break out into laughter together, a joke shared at my sister’s expense. Then I remember that my mom’s usually already left for work by this time.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Hey, why aren’t you at work?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("She waves me off. “I asked for permission to come in an hour late so I could get my children off to their first day of school.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Mom,” I moan, rolling my eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("I’m transferring my notebooks and stuff to my new backpack when another horn blares. I grab my dishes to put ‘em in the sink.")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“I’ll take care of those. You get going.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }, [_vm._v("“Thanks. Love you.” A quick peck on her cheek, I collect my new backpack, and off to start high school. "), _c('i', {
    staticClass: "calibre1"
  }, [_vm._v("Just hope it’s not a march to the gallows.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_12",
    attrs: {
      "id": "calibre_pb_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c8501e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_005.vue
// module id = 78
// module chunks = 0